module.exports = __webpack_public_path__ + "static/media/carousel_banner_2.67eb0928.png";